import '.c8{display:inline-flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.t{background-color:var(--palette-white);}.ssr-plugin'
import '.ia{padding:0.6rem;}.ssr-plugin'
import '.ib{border-radius:1.875rem;}.ssr-plugin'
import '.ic{border:1px solid var(--palette-blue-50);}.ssr-plugin'
import '.id{box-shadow:0 1rem 2rem 0.5rem var(--palette-blue-50);}.ssr-plugin'
import '.dg{border-radius:2rem;}.ssr-plugin'
import '.ie{overflow-x:hidden;}.ssr-plugin'
import '.bl{overflow-y:auto;}.ssr-plugin'
import '.if{background:var(--page-bg);}.ssr-plugin'
import '.ak{position:relative;}.ssr-plugin'
import { styled, type Style } from 'inlines'
import { ReactNode } from 'react'

export type PhoneFrameProps = {
  children: ReactNode
  width?: number
  height?: number
  style?: Style
}

export const PhoneFrame = ({
  children,
  width = 390,
  height = 760,
  style,
}: PhoneFrameProps) => {
  return (
    <styled.div className="c8 b r t ia ib ic id"
      style={{
        ...style,
      }}
    >
      <styled.div className="dg ie bl if ak"
        style={{
          width,
          height,}}
      >
        <div style={{ pointerEvents: 'none' }}>{children}</div>
      </styled.div>
    </styled.div>
  )
}
